import { slugify } from '@surfline/web-common';

export const spotForecastPaths = {
  base: 'surf-report',
  forecast: 'forecast',
  region: 'region',
};

export const spotReportPath = ({ _id, name }) => `${spotForecastPaths.base}/${slugify(name)}/${_id}`;

const spotForecastPath = ({ _id, name }) => `${spotForecastPaths.base}/${slugify(name)}/${_id}/${spotForecastPaths.forecast}`;

export default spotForecastPath;



// WEBPACK FOOTER //
// ./src/utils/urls/spotForecastPath.js